if(!customElements.get('announcement-bar-slider')) {
  class AnnouncementBarSlider extends HTMLElement {
    constructor() {
      super();

      this.swiper = this.querySelector('.swiper');

      if (this.swiper) {
        new Swiper(this.swiper, {
          spaceBetween: 0,
          slidesPerView: 1,
          effect: 'fade',
          fadeEffect: {
            crossFade: true
          },
          speed: 600,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          loop: true
        });
      }
    }
  }   

  customElements.define('announcement-bar-slider', AnnouncementBarSlider);
}